<template>
    
  <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>
   

    <h3 style="text-align: left;">Información General</h3>
    
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Nombre</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre"/>
                <label class="is-invalid">{{ validation.nombre }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Email</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.email"/>
                <label class="is-invalid">{{ validation.email }}</label>
            </div>
            <div class="col-md-4">
                <label for="">Telefono</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.telefono"/>
                <label class="is-invalid">{{ validation.telefono }}</label>
            </div>
        </div>
    </div>
    <hr>
    <h3>Informe resolutivo/estudio de Instalaciones de CENACE</h3>
    <div>
        <div class="py-3 col-md-12 row">
            <div class="col-md-4">
                <label for="">Dependencia</label><span class="is-invalid">*</span>
                <!--<input class="form-control" type="text" v-model="form.dependencia"/>-->
                <select class="form-control" v-model="form.dependencia">
                    <option value="Comision Federal de Electrecidad (CFE)">Comision Federal de Electrecidad (CFE)</option>
                    <option value="CENACE">CENACE</option>
                </select>
               
            </div>
            <div class="col-md-4">
                <label for="">Division</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.division"/>
                
            </div>
            <div class="col-md-4">
                <label for="">Zona</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.zona"/>
                <label class="is-invalid">{{ validation.zona }}</label>
            </div>
            
        </div>
    </div>
    <div>
        <div class="py-3 col-md-12 row">
            
            <div class="col-md-4">
                <label for="">Numero</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.numero"/>
                \
            </div>
            <div class="col-md-4">
                <label for="">Fecha</label><span class="is-invalid">*</span>
                <input class="form-control" type="date" v-model="form.fecha"/>
               
            </div>
            <div class="col-md-4">
                <label for="">Puesto de quien firma</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.puesto"/>
                
            </div>
        </div>
    </div>
    <div>
        <div class="py-3 col-md-12 row">
            
            <div class="col-md-4">
                <label for="">Nombre de quien firma</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.nombre_quien_firma"/>
                <label class="is-invalid">{{ validation.telefono }}</label>
            </div>
            
            <div class="col-md-4">
                <label for="">Lugar</label><span class="is-invalid">*</span>
                <input class="form-control" type="text" v-model="form.lugar"/>
                
            </div>
        </div>
    </div>
    <hr>
    <button type="button" v-if="existeInformacion == false" class="btn btn-dark" @click="guardar">Guardar datos de contacto</button>
    <button type="button" v-if="existeInformacion == true" class="btn btn-warning" @click="actualizar">Actualizar datos de contacto</button>

    </template>
    <script>
    import axios from 'axios';
    import Swal from 'sweetalert2';
    export default {
        data() {
            return {
                existeInformacion:false,
                isButton1Disabled: false,
                isButton2Disabled: true,
                form:{
                    nombre:'',
                    telefono:'',
                    email:'',
                    dependencia:'',
                    division:'',
                    zona:'',
                    numero:'',
                    fecha:'',
                    puesto:'',
                    nombre_quien_firma:'',
                    lugar:'',
                    usuario:'',
                    idcotizacion:"",
                    id:""
                },
                validation:{
                    nombre:"",
                    email:"",
                    telefono:""
                },
                existeInformacion:false,
                isLoading:false,
            }  
        },
        created() {
            this.consultar();
        },
        methods: {
            guardar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacion = idcotizacion;
                this.form.usuario = usuario;

                axios.post(this.$rutaServer+'guardarRegistro', this.form)
                .then(response => {
                    if (response.status == 201) {
                        Swal.fire('¡Éxito!', 'Datos registrados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                    }
                })
                .catch(error => {
                    if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }
                });
            },
            actualizar() {
                var idcotizacion = localStorage.getItem('idcotizacion');
                var usuario = localStorage.getItem('email');

                this.form.idcotizacion = idcotizacion;
                this.form.usuario = usuario;

                axios.post(this.$rutaServer+'actualizarRegistro', this.form)
                .then(response => {
                    if (response.status == 200) {
                        Swal.fire('¡Éxito!', 'Datos actualizados', 'success');
                        this.validation.nombre = '';
                        this.validation.email = '';
                        this.validation.telefono = '';
                        this.consultar();
                    }
                })
                .catch(error => {
                    if(error.response.data.errors?.nombre?.[0]){
                                this.validation.nombre = error.response.data.errors?.nombre?.[0];
                            }
                            if(error.response.data.errors?.email?.[0]){
                                this.validation.email = error.response.data.errors?.email?.[0];
                            }
                            if(error.response.data.errors?.telefono?.[0]){
                                this.validation.telefono = error.response.data.errors?.telefono?.[0];
                            }
                });
            },
            consultar(){
                this.isLoading = true;
                var idcotizacion = localStorage.getItem('idcotizacion');
                
                axios.post(this.$rutaServer+'consultarRegistro',{idcotizacion:idcotizacion} )
                .then(response => {
                    if (response.status == 200) {
                        this.isLoading = false;
                        if(response.data.length > 0){
                            this.existeInformacion = true;
                        }
                        this.form.nombre = response.data[0].nombre;
                        this.form.email = response.data[0].email;
                        this.form.telefono = response.data[0].telefono;
                        this.form.id = response.data[0].id;
                        this.form.dependencia = response.data[0].dependencia;
                        this.form.division = response.data[0].division;
                        this.form.zona = response.data[0].zona;
                        this.form.numero = response.data[0].numero;
                        this.form.fecha = response.data[0].fecha;
                        this.form.puesto = response.data[0].puesto;
                        this.form.nombre_quien_firma = response.data[0].nombre_quien_firma;
                        this.form.lugar = response.data[0].lugar;

                    }
                })
                .catch(error => {
                    
                });
            }
        },
            
    };
    </script>